import BccRwdComponentList from 'components/Bcc/BccRwdComponentList/BccRwdComponentList';

export default BccRwdComponentList;
